

























































































































































  import { Component, Vue } from "vue-property-decorator";
  import VueElementLoading from "vue-element-loading";
  import { RotateSquare2 } from "vue-loading-spinner";
  import { store, StoreState } from "../store";
  import { mapState } from "vuex";
  import { SIDEBAR_DATA } from "../lib/constant";
  import DashLogo from "./DashLogo.vue";
  import AES from 'crypto-js/aes';
  import CryptoJS from 'crypto-js';
  import logout from '../../src/components/LogoutModel.vue';
  import NotificationModal from '../views/NotifiactionModal.vue'
@Component({
  components: {
    RotateSquare2,
    VueElementLoading,
    DashLogo,logout,NotificationModal
  },
  computed: {   
    ...mapState({
      notifications: (state: StoreState) => state.dashboard.notifications,
      notification_load: (state: StoreState) =>state.dashboard.admin.notification_load,
      userfirstname: (state: StoreState) => state.dashboard.userfirstname,
      userlastname: (state: StoreState) => state.dashboard.userlastname,
      privilege_level:(state: StoreState) => state.account.privilege_level,
      'user_image_url': (state: StoreState) => state.dashboard.user_image_url,
      'session_timeout': (state: StoreState) => state.account.logout_status ,
      'ringtone': (state: StoreState) =>  state.dashboard.notifiaction_ringtone,
      'contacts': (state: StoreState) =>state.dashboard.contacts,
      'account_id':(state: StoreState)=>state.account.account_id,
      contactsidebar_status: (state: StoreState) =>state.dashboard.contactsidebar_status,

    })
  },
   mounted: function() {
      this.created_sample();
            this.$store.commit("CONTACT_SIDEBARSTATSU", "personal");
    },
     methods: {
        handleFocusOut() {
           this.$data.notify=this.$data.model_status=false;
        }
    }
    
})
export default class Sidebar extends Vue {
  data() {
    return {
      sidebarIcons: SIDEBAR_DATA.icons,
      is_loading: false,
      active_imagebell:'',
      active_imagecontact:'',
      model_status:false,
      logout_modal:false,
      src_url:'/img/for-sure.mp3',
      c: 0,
      t:'',
      timer_is_on : 0,
      Bell_ntfcnt:false,
      notify:false
     
    };
  }

   updateStore() {
    this.$store.commit("TAB_MANAG",{evt:''})
  }
  created(){
     this.created_sample();
  }

 log_outclick(){
    this.$data.logout_modal=true
 }
  model_statusent(){
     this.$data.notify=false;
    this.$data.model_status=true;
  }
  Notificationmodal(){
    this.$data.model_status=false;
    this.$data.notify=true;
  }

   created_sample() {
     this.$store.dispatch("getSettings");
      this.$store.commit("SET_ADMIN_LOADER", true);
      this.$store.dispatch('getTextPermissions').then( (r) => {
     // this.$store.dispatch("getContacts").then( (r) => {
       this.$store.dispatch('createNotificationsSocket');
        this.$store.dispatch('checkNotifications').then( (r) => {
          console.log('checkNotifications sidebar')
        this.$data.notinction_loader=false
      } );
     // } );
    
        } );

    // if (!(this as any).contacts || (this as any).contacts.length==0)
    // {
    //   this.$store.commit("SET_ADMIN_LOADER", true);
    //   this.$store.dispatch('getTextPermissions').then( (r) => {
    //   this.$store.dispatch("getContacts").then( (r) => {
    //    this.$store.dispatch('createNotificationsSocket');
    //     this.$store.dispatch('checkNotifications').then( (r) => {
    //     this.$data.notinction_loader=false
    //   } );
    //   } );
    
    //     } );
    // }
    // else{
    // this.$store.dispatch('getTextPermissions').then( (r) => {
    //   this.$store.dispatch('createNotificationsSocket');
    //   this.$store.dispatch('checkNotifications').then( (r) => {
    //   this.$data.notinction_loader=false
    //   } );
    //     } );
    // }
     const routeId = (this as any).$router.history.current.name;
    this.$data.sidebarIcons.map(ob => {
      (ob.active = false);
    });
    const filteredArray = this.$data.sidebarIcons.filter(obj => obj.id === routeId);
    if(filteredArray.length > 0) filteredArray[0].active = true;
   }


  
  canplayaudio()
    {
        // (this.$refs.audio as HTMLAudioElement).play();
        if (this.$refs.audio) {
        (this.$refs.audio as HTMLAudioElement).play();
        }
    }

   my_setting(){
       this.$router.push("/MySettings");
    }

    Notification(data){
      this.$data.active_imagebell=!this.$data.active_imagebell;
    }
    Contact(data){
      this.$data.active_imagecontact=!this.$data.active_imagecontact;
    }

    get login_active() {
			return (this as any).$route.path === "/login";
    }
    get notification_active() {
			return (this as any).$route.path === "/alerts";
    }
    get contact_active() {
			// return (this as any).$route.path === "/contactsinfo";
			return (this as any).$route.path === "/ContactsInfo_sp2"; //
		}
		get conference_active() {
			return (this as any).$route.path === "/conference";
    }
    get report_active() {
       return (this as any).$route.path === "/reports";  //"/reporting";         
    }
    get calreport_active()
    {
       return (this as any).$route.path === "/customreports/expressfuneral";   
    }
    get contactMessageHistory()
    {
      return (this as any).$route.path === "/TextingPanel";
    }
    get admin_active() {
			return (this as any).$route.path === "/admin";  
    }
    get mysettings_active() {
			return (this as any).$route.path === "/MySettings";
    } 
    get voicemail_active() {
			return (this as any).$route.path === "/voicemails";   
    }
    

  logout__() {
  
    var self=this;
    this['$iziToast'].question({
        overlay: true,
        timeout: false,
        toastOnce: true,
        title: 'Are you sure you want to logout?',
        position: 'center',
        icon: '',
        buttons: [
            ['<button><b>LOG OUT</b></button>', function (instance, toast) {
                   self.$store.dispatch('logout');  
                   instance.hide({ transitionOut: 'fadeOut' }, toast);
            }, true],
            ['<button>CANCEL</button>', function (instance, toast) {
                instance.hide({ transitionOut: 'fadeOut' }, toast);
            }]
        ]
      });
  }

 

   get notification_status(){
        console.log('notification_status');
        return (this as any).notifications.filter((e) => e.read == false).length
		}


  routeTo(o, index) {
    this.$data.sidebarIcons.map(ob => {
      (ob.display = false);
    });
    if(o.route !== "/reporting") {
      if(o.route !== "/logout") {
        this.$data.sidebarIcons.map(ob => {
          (ob.active = false);
        });
        this.$data.sidebarIcons[index].active = true;
      }
    }
    this.$store.commit('CHANGE_SELECTED_CONTACT', null);

    if (o.route == "/logout") {
      this.$store.commit("LOGOUT_STATUS", true);
    } 
    else if(o.route == "/reporting"){
      let routeData = this.$router.resolve({name: location.protocol +'//' + location.host+'/reporting'});     
      window.open(routeData.location.name, '_blank');
    }
    else {
      this.$router.push(o.route);
    }
  }
  Reporting_rout(){
      let routeData = this.$router.resolve({name: location.protocol +'//' + location.host+'/reporting'});     
      window.open(routeData.location.name, '_blank');
  }

  Dashboard_rout(){
     this.$emit('dasbord')
     this.$router.push("/dashboard");
  }


  displayTooltipOver(o, index) {
    this.$data.sidebarIcons.map(ob => {
      ob.display = false;
    });
    this.$data.sidebarIcons[index].display = true;
  }
  displayTooltipOut(o, index) {
    this.$data.sidebarIcons.map(ob => {
      ob.display = false;
    });
  }
  Home() {
    this.$data.sidebarIcons.map(ob => {
      (ob.display = false), (ob.active = false);
    });
    this.$router.push("/dashboard");
  }
  get loger_Name(){   
			this.$data.notifications_open = true;
			var Login_User=AES.decrypt(decodeURI((this as any).$cookies.get('username')),"2r5u8x/A").toString(CryptoJS.enc.Utf8);
      Login_User=Login_User.substring(0,Login_User.indexOf('@'));
      Login_User=Login_User.charAt(0).toUpperCase()+ Login_User.slice(1)
      Login_User=Login_User; // "Hi"+','+ 
			return Login_User
        }

}
